import classNames from 'classnames';
import React from 'react';
import Badge from '../components/Badge';
import SVGIcon from '../components/SVGIcon';
import keyIcon from '../icons/non-prefilled/16x16/key.svg';
import styles from './AdminBadge.module.scss';

interface AdminBadgeProps {
  focused?: boolean;
}

const AdminBadge = ({ focused }: AdminBadgeProps) => (
  <Badge
    inline={false}
    color="blue"
    className={classNames(styles.badge, { [styles.bordered]: focused })}
  >
    <SVGIcon size={9}>{keyIcon}</SVGIcon>
    USE ADMIN
  </Badge>
);

export default AdminBadge;
